import { render, staticRenderFns } from "./WordleInputLabel.vue?vue&type=template&id=a1b1c0a8&scoped=true"
import script from "./WordleInputLabel.vue?vue&type=script&lang=js"
export * from "./WordleInputLabel.vue?vue&type=script&lang=js"
import style0 from "./WordleInputLabel.vue?vue&type=style&index=0&id=a1b1c0a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b1c0a8",
  null
  
)

export default component.exports